import AddTodo from "../../Components/Modals/AddTodo";
import Table from "../../Components/Table";
import { deleteTodoById, getAllTodo } from "../../Services/MasterService";

const Todo = () => {
    const columns = [
        {
            label: "Title",
            value: "title"
        },
        {
            label: "Description",
            value: "descriptionail"
        },
        {
            label: "CTA Name",
            value: "cta_name"
        },
        {
            label: "Default",
            value: "is_default",
            renderValue: (value) => {
                return (
                    <p>{Boolean(value) ? "Yes" : 'No'}</p>
                )
            }
        },
        {
            label: "Parent",
            value: "parent_title"
        },
        {
            label: "Type",
            value: "type"
        },
        {
            label: "Alias",
            value: "alias"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddTodo data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllTodo}
            columns={columns}
            title={"Todo Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteTodoById}
        />
    );
}

export default Todo;